import { registerErrorReportingDataExtractionFn } from "./errorReporting/reportingDataExtraction";
export class MissingPathParameterError extends Error {
    paramName;
    constructor(paramName) {
        super(`Parameter "${paramName}" is missing in path`);
        this.paramName = paramName;
        this.name = "MissingPathParameterError";
        Object.setPrototypeOf(this, MissingPathParameterError.prototype);
    }
}
registerErrorReportingDataExtractionFn((error) => {
    if (error instanceof MissingPathParameterError) {
        const docHasReferrer = document.referrer;
        return {
            extra: {
                missingPathParameter: error.paramName,
            },
            noReport: !docHasReferrer,
        };
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWlzc2luZ1BhdGhQYXJhbWV0ZXJFcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lcnJvcnMvTWlzc2luZ1BhdGhQYXJhbWV0ZXJFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsc0NBQXNDLEVBQUUsTUFBTSwwQ0FBMEMsQ0FBQztBQUVsRyxNQUFNLE9BQU8seUJBQTBCLFNBQVEsS0FBSztJQUNsQyxTQUFTLENBQVM7SUFFbEMsWUFBbUIsU0FBaUI7UUFDbEMsS0FBSyxDQUFDLGNBQWMsU0FBUyxzQkFBc0IsQ0FBQyxDQUFDO1FBQ3JELElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1FBRTNCLElBQUksQ0FBQyxJQUFJLEdBQUcsMkJBQTJCLENBQUM7UUFDeEMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxJQUFJLEVBQUUseUJBQXlCLENBQUMsU0FBUyxDQUFDLENBQUM7SUFDbkUsQ0FBQztDQUNGO0FBRUQsc0NBQXNDLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRTtJQUMvQyxJQUFJLEtBQUssWUFBWSx5QkFBeUIsRUFBRSxDQUFDO1FBQy9DLE1BQU0sY0FBYyxHQUFHLFFBQVEsQ0FBQyxRQUFRLENBQUM7UUFDekMsT0FBTztZQUNMLEtBQUssRUFBRTtnQkFDTCxvQkFBb0IsRUFBRSxLQUFLLENBQUMsU0FBUzthQUN0QztZQUNELFFBQVEsRUFBRSxDQUFDLGNBQWM7U0FDMUIsQ0FBQztJQUNKLENBQUM7QUFDSCxDQUFDLENBQUMsQ0FBQyJ9